import styles from "./Content.module.scss";

export interface ContentProps {
  reverseImage: string;
}

export const DummyCardContent = (props: ContentProps) => {
  const { reverseImage } = props;

  return (
    <div className={styles.wrapper}>
      <img className={styles.cardReverseImage} src={reverseImage} alt="card revers" />
    </div>
  );
};
